/**
 * Extract location from EXIF GPS data in a photo file.
 * Used when uploading a spot to pre-fill location from the image.
 */
import exifr from 'exifr';

export interface ExifLocation {
  location?: string;
  city?: string;
}

/**
 * Parse a photo file for GPS EXIF and return a location string (and optional city if present).
 * Returns empty object if no GPS data or on parse error.
 */
export async function extractLocationFromExif(file: File): Promise<ExifLocation> {
  try {
    const gps = await exifr.gps(file);
    if (!gps || typeof gps.latitude !== 'number' || typeof gps.longitude !== 'number') {
      return {};
    }
    const lat = gps.latitude;
    const lng = gps.longitude;
    const latStr = lat.toFixed(5);
    const lngStr = lng.toFixed(5);
    const location = `${latStr}, ${lngStr}`;
    return { location };
  } catch {
    return {};
  }
}
